// Try to fetch script from tripping avanger with name openad.js
// which is blocked by adblockers. Inspirated by https://www.detectadblock.com/
// Filenames and urls blacklist: https://easylist-downloads.adblockplus.org/easylist.txt
export const probeAdblock = async () => {
  let adblock = false

  try {
    await fetch('https://static.twistopay.com/base/js/openad.js', {
      mode: 'no-cors',
    })
  } catch (e) {
    adblock = true
  }

  return adblock
}
